export const MORNING_THEME_STORAGE_KEY = 'morning-theme'

export type MorningTheme = 'light' | 'dark'

export function readStoredTheme(): MorningTheme {
  try {
    const v = localStorage.getItem(MORNING_THEME_STORAGE_KEY)
    if (v === 'light' || v === 'dark') return v
  } catch {
    /* ignore */
  }
  return 'light'
}

export function writeStoredTheme(theme: MorningTheme) {
  try {
    localStorage.setItem(MORNING_THEME_STORAGE_KEY, theme)
  } catch {
    /* ignore */
  }
}

/** Syncs `<html class="dark">` with theme (shadcn / Tailwind `dark:` variant). */
export function applyThemeToDocument(theme: MorningTheme) {
  const root = document.documentElement
  if (theme === 'dark') root.classList.add('dark')
  else root.classList.remove('dark')
}
